<template>
  <div class="school">
    <iframe
      :src="schoolUrl"
      frameborder="0"
      class="school_content"
    />
    <div
      class="loginBack"
      :style="schoolRight"
      @click="goBack"
      @touchend="goBack"
    >
      返回註冊登錄
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schoolUrl: ''
    };
  },

  computed: {
    schoolRight() {
      let scrollWidths = document.body.scrollWidth;
      if (scrollWidths > 600) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.schoolUrl = 'https://promotion.house730.com/newuser_pc/';
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.schoolUrl = 'https://promotion.house730.com/newuser_app/';
      }
      return '';
    }
  },

  methods: {
    goBack() {
      // this.$router.push('/login');
      let url = this.pub.getLang() === 'zh-cn' ? 'zh-cn/' : this.pub.getLang() === 'en-us' ? 'en-us/' : '';
      window.location.href = this.pub.config.pcUrl+'my/' + url +'login/?tab=1';
    }
  }
};
</script>
<style lang="scss">
.school {
  width: 100%;
  height: 100%;
  position: fixed;
  // -webkit-overflow-scrolling: touch;
  .school_content {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    z-index: -1;
  }

  .loginBack {
    cursor: pointer;
    position: absolute;
    right: 20px;
    bottom: 30px;
    color: #fff;
    font-size: 14px;
    z-index: 99;
  }
}
@media screen and (min-width: 1125px) {
  .school {
    .loginBack {
      right: calc(100% - 1125px) + 20px;
    }
  }
}
</style>
